import React from 'react'
import { IoMailUnreadOutline } from "react-icons/io5";
import { FaPhoneVolume } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
const Header = () => {
  return (
   <section id='header' className='bg-[#000000] h-[51px]' >
     <div className='max-w-container mx-auto py-[16px] flex w-full'>
       <div className="flex w-1/3 text-white">
       <IoMailUnreadOutline /> <p className='mt-[-5px] ml-[4px] font-poppi' >mail@yourcompany.com</p>
       </div>
       <div className="w-1/3 flex text-white ml-[-100px]" >
       < FaPhoneVolume /><p className='mt-[-5px] ml-[4px] font-poppi' >+896 120 5889 (Toll free)</p>
       </div>
       <div className="w-1/3 items-end text-white justify-end flex">
       <div className="pr-[19px]"><FaFacebookF /></div>
       <div className="pr-[19px]"><FaTwitter /></div>
       <div className="pr-[19px]"><FaLinkedinIn /></div>
       <div className="pr-[19px]"><FaInstagram /></div>
       
       
       </div>
    </div>
   </section>
  )
}

export default Header